// NOTE: Decision policy for refreshing the chat socket's auth after a REST token
// refresh. Kept a pure function so the branch matrix can be unit-tested without
// spinning up a live socket. Shared (NSAI-5117) because both clients run the same
// transport; a platform opts in by supplying `hasActiveStream` to the service.

export interface IAuthReconnectDecisionProps {
  isConnected: boolean;
  hasActiveStream: boolean;
}

// NOTE: Defer the disconnect/reconnect ONLY while a generation is actively
// streaming on a connected socket. A forced disconnect there would drop the
// in-flight — often still-empty — assistant message and surface a spurious
// "connection lost" (the multi-model failure where slow reasoning models die while
// a fast one survives). Stream delivery is a server room broadcast that needs no
// re-auth, so the live stream is safe; the refreshed token is applied by a deferred
// reconnect that runs as soon as the stream settles (see WebSocketService.flushDeferredAuthReconnect).
//
// Pending tool approvals are intentionally NOT treated as a reason to defer: those
// flows need a guarded client->server emit (`toolApprovalResponse`) that the server
// re-authenticates from the handshake token, so they must reconnect promptly with a
// fresh token rather than wait — otherwise an expired token could deadlock the turn.
export const shouldDeferAuthReconnectForActiveStream = (
  props: IAuthReconnectDecisionProps,
): boolean => {
  return props.isConnected && props.hasActiveStream;
};
